import { render, staticRenderFns } from "./SpecialCommitChip.vue?vue&type=template&id=fd1eeae8"
import script from "./SpecialCommitChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpecialCommitChip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports